import React from 'react';
import Tag from '../../../../components/Display/Tag';
import { getConstant } from '../../../../utils/constants';

function ExternalResourceItem({ resource, handleClickResource }) {
  return (
    <div className="flex flex-row items-center py-5 px-3 gap-x-5   h-44 shadow-xl ">
      <div
        className={`flex flex-row items-center py-5 px-3 gap-x-5   w-full h-44 ${
          handleClickResource && 'cursor-pointer hover:bg-slate-100'
        }`}
        onClick={handleClickResource || undefined}>
        <div className="flex flex-col justify-around h-full w-full">
          <div className="flex flex-col gap-y-1">
            <div className="text-xl font-bold text-slate-700 ">{resource.title}</div>
            <div className="text-sm  text-slate-700 ">{resource.src_url}</div>
          </div>
          <div className="flex flex-row gap-x-3">
            <Tag
              tag={{
                label: getConstant('solarys.themeList', resource.theme).label,
                icon: 'colors',
                bgColor: 'bg-orange-700'
              }}
            />
            {resource.public_list.map((o, key) => (
              <Tag
                key={key}
                tag={{
                  label: o.label,
                  icon: 'man',
                  bgColor: 'bg-yellow-500'
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ExternalResourceItem;
